import Modal from "@/components/Common/Modals";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

interface VestingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const VestingModal = ({ isOpen, onClose }: VestingModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onCancel={onClose} widthSize="md:w-[600px]">
      <div className="p-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-gray-900">
            {t("home.vesting_modal.title")}
          </h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors duration-200"
            aria-label={t("home.vesting_modal.close_modal")}
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="space-y-4 text-black leading-relaxed">
          <p className="text-[16px]">{t("home.vesting_modal.description")}</p>

          <div className="bg-gray-100 border border-gray-300 rounded-lg p-4">
            <h3 className="font-semibold text-black text-[18px] mb-2">
              {t("home.vesting_modal.three_year_cliff.title")}
            </h3>
            <div className="text-[16px] space-y-1">
              <div className="flex justify-between">
                <span>
                  {t("home.vesting_modal.three_year_cliff.years_1_2")}
                </span>
                <span className="font-medium">
                  {t("home.vesting_modal.three_year_cliff.zero_percent")}
                </span>
              </div>
              <div className="flex justify-between">
                <span>
                  {t("home.vesting_modal.three_year_cliff.year_3_plus")}
                </span>
                <span className="font-medium">
                  {t("home.vesting_modal.three_year_cliff.hundred_percent")}
                </span>
              </div>
            </div>
            <p className="text-[16px] text-black mt-2">
              {t("home.vesting_modal.three_year_cliff.description")}
            </p>
          </div>

          <div className="bg-gray-100 border border-gray-300 rounded-lg p-4">
            <h3 className="font-semibold text-black text-[18px] mb-2">
              {t("home.vesting_modal.five_year_graded.title")}
            </h3>
            <div className="text-[16px] space-y-1">
              <div className="flex justify-between">
                <span>{t("home.vesting_modal.five_year_graded.year_1")}</span>
                <span className="font-medium">
                  {t("home.vesting_modal.five_year_graded.twenty_percent")}
                </span>
              </div>
              <div className="flex justify-between">
                <span>{t("home.vesting_modal.five_year_graded.year_2")}</span>
                <span className="font-medium">
                  {t("home.vesting_modal.five_year_graded.forty_percent")}
                </span>
              </div>
              <div className="flex justify-between">
                <span>{t("home.vesting_modal.five_year_graded.year_3")}</span>
                <span className="font-medium">
                  {t("home.vesting_modal.five_year_graded.sixty_percent")}
                </span>
              </div>
              <div className="flex justify-between">
                <span>{t("home.vesting_modal.five_year_graded.year_4")}</span>
                <span className="font-medium">
                  {t("home.vesting_modal.five_year_graded.eighty_percent")}
                </span>
              </div>
              <div className="flex justify-between">
                <span>
                  {t("home.vesting_modal.five_year_graded.year_5_plus")}
                </span>
                <span className="font-medium">
                  {t("home.vesting_modal.five_year_graded.hundred_percent")}
                </span>
              </div>
            </div>
            <p className="text-[16px] text-black mt-2">
              {t("home.vesting_modal.five_year_graded.description")}
            </p>
          </div>

          <div className="bg-gray-100 border border-gray-300 rounded-lg p-4">
            <h3 className="font-semibold text-black text-[18px] mb-2">
              {t("home.vesting_modal.other_types.title")}
            </h3>
            <div className="text-[16px] space-y-2">
              <div>
                <span className="font-medium">
                  {t("home.vesting_modal.other_types.immediate_label")}
                </span>
                <span className="ml-2">
                  {t("home.vesting_modal.other_types.immediate_description")}
                </span>
              </div>
              {/* <div>
                <span className="font-medium">
                  {t("home.vesting_modal.other_types.three_year_cliff_label")}
                </span>
                <span className="ml-2">
                  {t(
                    "home.vesting_modal.other_types.three_year_cliff_description",
                  )}
                </span>
              </div>
              <div>
                <span className="font-medium">
                  {t("home.vesting_modal.other_types.five_year_graded_label")}
                </span>
                <span className="ml-2">
                  {t(
                    "home.vesting_modal.other_types.five_year_graded_description",
                  )}
                </span>
              </div> */}
            </div>
          </div>
        </div>

        <div className="flex justify-end mt-6 pt-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-brand-default text-white rounded-lg hover:bg-opacity-90 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-brand-default focus:ring-offset-2"
          >
            {t("home.vesting_modal.got_it_button")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default VestingModal;
